<template>
    <div>
        <div
            v-if="!$store.getters.isLoggedIn || $store.getters.isAnonymous"
            class="navbar-item is-marginless is-inline-flex"
        >
            <div class="buttons">
                <a
                    class="lb-button is-primary lb-login-button"
                    @click="requestLogin"
                >
                    <mq-layout mq="mobile">
                        <span>{{ $t('log_in_mobile') }}</span>
                    </mq-layout>
                    <mq-layout mq="tablet+">
                        <span>{{ $t('log_in') }}</span>
                    </mq-layout>
                </a>
            </div>
        </div>
        <div
            v-else
            :class="{ 'has-dropdown is-hoverable ': windowSize !== 'mobile' }"
            class="navbar-item is-inline-flex py-1"
        >
            <mq-layout mq="tablet+">
                <router-link
                    v-if="!$store.getters.isAnonymous"
                    class="navbar-link has-text-centered-mobile"
                    to="/profile"
                    tag="a"
                >
                    <div class="level is-mobile">
                        <div class="level-item">
                            <div style="margin: 5px">
                                <div
                                    :style="getAvatarStyle"
                                    class="image is-24x24 is-pulled-right"
                                />
                            </div>
                            <mq-layout mq="mobile">
                                <span>{{ $t('Navbar.edit_my_profile') }}</span>
                            </mq-layout>
                        </div>
                    </div>
                </router-link>

                <div
                    v-if="$store.getters.isAnonymous"
                    class="navbar-link has-text-centered-mobile"
                >
                    <div class="level is-mobile">
                        <div class="level-item">
                            <div style="margin: 5px">
                                <div
                                    :style="getAvatarStyle"
                                    class="image is-24x24 is-pulled-right"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="navbar-dropdown is-boxed is-right mr-4">
                    <p
                        class="
                            navbar-item
                            has-text-centered-mobile
                            is-size-6-mobile
                            has-text-weight-bold
                        "
                        v-if="$store.getters.isAnonymous"
                    >
                        {{ personalData.alias }}
                    </p>
                    <hr
                        v-if="$store.getters.isAnonymous"
                        class="dropdown-divider"
                    />
                    <router-link
                        v-if="!$store.getters.isAnonymous"
                        tag="a"
                        class="navbar-item is-hidden-mobile"
                        to="/profile"
                        >{{ $t('Navbar.edit_my_profile') }}</router-link
                    >
                    <a
                        class="
                            navbar-item
                            has-text-centered-mobile
                            is-size-6-mobile
                        "
                        @click="logout"
                        >{{ $t('log_out') }}</a
                    >
                </div>
            </mq-layout>
            <mq-layout mq="mobile">
                <div class="dropdown is-right is-hoverable">
                    <div class="dropdown-trigger">
                        <button
                            class="button is-borderless px-0"
                            aria-haspopup="true"
                            aria-controls="mobile-user-menu"
                        >
                            <div style="margin: 5px">
                                <div
                                    :style="getAvatarStyle"
                                    class="image is-24x24 is-pulled-right"
                                />
                            </div>
                            <span class="icon is-small">
                                <i
                                    class="fas fa-angle-down"
                                    aria-hidden="true"
                                ></i>
                            </span>
                        </button>
                    </div>
                    <div
                        id="mobile-user-menu"
                        class="dropdown-menu"
                        role="menu"
                    >
                        <div class="dropdown-content">
                            <router-link
                                v-if="!$store.getters.isAnonymous"
                                class="
                                    dropdown-item
                                    has-text-centered-mobile
                                    is-size-6-mobile
                                "
                                to="/profile"
                                tag="a"
                            >
                                <span>{{ $t('Navbar.edit_my_profile') }}</span>
                            </router-link>
                            <a
                                class="
                                    dropdown-item
                                    has-text-centered-mobile
                                    is-size-6-mobile
                                "
                                @click="logout"
                                >{{ $t('log_out') }}</a
                            >
                        </div>
                    </div>
                </div>
            </mq-layout>
        </div>
        <div
            class="navbar-item has-dropdown is-hoverable is-inline-flex"
            :class="{
                'has-bottom-6':
                    $store.getters.isLoggedIn && !$store.getters.isAnonymous,
            }"
            v-if="windowSize !== 'mobile'"
        >
            <a class="navbar-link has-text-centered-mobile">
                {{ this.$i18n.locale | localePrint }}
            </a>

            <div class="navbar-dropdown is-boxed is-right">
                <a
                    v-for="locale in locales"
                    :key="locale"
                    @click="switchLocale(locale)"
                    class="navbar-item"
                >
                    {{ locale | localePrint }}
                </a>
            </div>
        </div>

        <div v-else class="dropdown is-right is-hoverable pt-1">
            <div class="dropdown-trigger">
                <button
                    class="button is-borderless px-0"
                    aria-haspopup="true"
                    aria-controls="mobile-language-menu"
                >
                    <div style="margin: 5px">
                        {{ this.$i18n.locale | localePrint }}
                    </div>
                    <span class="icon is-small">
                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                    </span>
                </button>
            </div>
            <div id="mobile-language-menu" class="dropdown-menu" role="menu">
                <div class="dropdown-content">
                    <a
                        v-for="locale in locales"
                        :key="locale"
                        @click="switchLocale(locale)"
                        class="navbar-item"
                    >
                        {{ locale | localePrint }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthService from '@/services/auth.service';
import { avatarStyle } from '@/lib/helpers';
export default {
    data() {
        return {
            locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(','),
        };
    },
    filters: {
        localePrint(locale) {
            return locale.slice(0, 2).toUpperCase();
        },
    },
    computed: {
        personalData() {
            return this.$store.getters.personalData;
        },
        windowSize() {
            return this.$mq;
        },
        hasImage() {
            if (
                this.$store.getters.personalData.image &&
                this.$store.getters.personalData.image.url
            ) {
                return true;
            }
            return false;
        },
        getAvatarStyle() {
            return avatarStyle(this.personalData);
        },
    },
    created() {
        this.authService = new AuthService();
    },
    mounted() {},
    methods: {
        requestLogin() {
            this.$store.dispatch('requestLoginForm');
        },
        logout() {
            if (this.$gapi.isAuthenticated()) {
                this.$gapi.logout();
            }
            this.$store.dispatch('logout');
            this.$router.push('/');
        },
        switchLocale(locale) {
            if (this.$i18n.locale !== locale) {
                this.$i18n.locale = locale;
            }
        },
    },
};
</script>

<style scoped>
.lb-login-button {
    height: 2.4rem !important;
}
.has-dropdown {
    padding: unset !important;
}
.is-borderless,
.is-borderless:hover {
    border: none;
}
.has-bottom-6 {
    bottom: 6px;
}
</style>
